import Footer from "../../components/VibrantSolComponents/Footer";
import Header from "../../components/VibrantSolComponents/Header";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  MapPin,
  Phone,
  Clock,
  Leaf,
  Heart,
  Gift,
  Twitter,
  Instagram,
  Youtube,
  LucideYoutube,
} from "lucide-react";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";
import whychooseimg2 from "../../why-choose-img-2.jpg";
import TeamImg from "../../our-team-01.jpg";
import TeamImg1 from "../../our-team-02.jpg";
import TeamImg2 from "../../our-team-03.jpg";
import TeamImg3 from "../../our-team-04.jpg";
function AboutUs() {
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              {/* Separator */}
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">About Us</span>
            </li>
          </ol>
        </nav>

        <section class="py-20">
          <div class="max-w-7xl mx-auto px-4">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div class="card border-0 hover:scale-105 transition-transform duration-500">
                <div class="overflow-hidden rounded-lg">
                  <img
                    src={whychooseimg2}
                    alt="About Glowing"
                    class="w-full h-auto object-cover"
                  />
                </div>
              </div>

              <div class="px-4 lg:px-12 mt-12 lg:mt-0">
                <h2 class="mb-8 text-3xl font-bold secdory-font">
                  About VibranceSol
                </h2>
                <p class="text-gray-700">
                  At VibranceSol, we are dedicated to helping individuals
                  achieve their best selves — inside and out. Our holistic
                  approach combines science, innovation, and personalized care
                  to address the unique needs of every client. From restoring
                  confidence through hair regrowth solutions to enhancing
                  overall wellness, we believe true vibrance comes from balance,
                  health, and self-care.
                </p>
                <p class="mt-12 text-gray-700">
                  We work with a team of specialists and use advanced, safe, and
                  effective methods to deliver lasting results. Every service is
                  designed with your well-being in mind, empowering you to look
                  good, feel great, and live with confidence.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-section-6">
          <div className="max-w-7xl mx-auto px-4">
            <div class="text-center mb-12">
              <h2 class="text-3xl md:text-4xl font-semibold max-w-2xl mx-auto mb-6 secdory-font">
                We strive to live with compassion, kindness, and empathy
              </h2>
              <p class="text-lg text-slate-600 max-w-3xl mx-auto">
                At VibranceSol, we believe true wellness comes from harmony
                between mind, body, and spirit. Our solutions are designed to
                deliver safe, effective, and lasting results while maintaining
                the highest standards of quality.
              </p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
              <div class="flex flex-col items-center text-center">
                <Leaf size={64} strokeWidth={1} className="mb-3" />
                <h3 class="text-xl font-semibold mb-4 secdory-font">
                  Pure & Safe Formulations
                </h3>
                <p class="text-gray-600">
                  Every VibranceSol product is crafted with natural, non-toxic
                  ingredients, ensuring your wellness journey is free from
                  harmful chemicals.
                </p>
              </div>

              <div class="flex flex-col items-center text-center">
                <Heart size={64} strokeWidth={1} className="mb-3" />
                <h3 class="text-xl font-semibold mb-4 secdory-font">
                  Cruelty-Free Commitment
                </h3>
                <p class="text-gray-600">
                  We are committed to being 100% cruelty-free — no product is
                  ever tested on animals, and we source responsibly.
                </p>
              </div>

              <div class="flex flex-col items-center text-center">
                <Gift size={64} strokeWidth={1} className="mb-3" />
                <h3 class="text-xl font-semibold mb-4 secdory-font">
                  Ethical Ingredient Sourcing
                </h3>
                <p class="text-gray-600">
                  We partner with trusted suppliers to source high-quality,
                  sustainable ingredients that support both your health and the
                  planet.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="pt-20 pb-16 lg:py-18">
          <div className="max-w-7xl mx-auto px-4">
            {/* Heading */}
            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl mx-auto mb-4 max-w-[483px] secdory-font">
                We pride ourselves on have a team of highly skilled
              </h3>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                Not cool. Our tightly knitted fabric holds its form after
                repeated wear. Plus, Aldays dress up or down, no prob. So you
                can wear them all day. Get it?
              </p>
            </div>

            {/* Team Grid */}
            <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {/* Card 1 */}
              <div className="group border-0">
                <div className="relative overflow-hidden">
                  <img
                    src={TeamImg}
                    alt="Slava Fedutik"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 flex flex-col justify-end items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <ul className="flex gap-6 bg-gray-100 w-full justify-center py-5">
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Twitter size={18} />
                        </a>
                      </li>

                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Instagram size={18} />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <LucideYoutube size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-center py-4">
                  <h4 className="text-xl md:text-2xl secdory-font">
                    <a href="#" className="no-underline">
                      Slava Fedutik
                    </a>
                  </h4>
                  <p className="text-gray-500">Founder, Chief Creative</p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="group border-0">
                <div className="relative overflow-hidden">
                  <img
                    src={TeamImg1}
                    alt="Jennifer C."
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex flex-col justify-end items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <ul className="flex gap-6 bg-gray-100 w-full justify-center py-5">
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Twitter size={18} />
                        </a>
                      </li>

                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Instagram size={18} />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <LucideYoutube size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-center py-7">
                  <h4 className="text-xl md:text-2xl secdory-font">
                    <a href="#" className="no-underline">
                      Jennifer C.
                    </a>
                  </h4>
                  <p className="text-gray-500">Founder, CEO</p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="group border-0">
                <div className="relative overflow-hidden">
                  <img
                    src={TeamImg2}
                    alt="Valeriia Nadopta"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex flex-col justify-end items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <ul className="flex gap-6 bg-gray-100 w-full justify-center py-5">
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Twitter size={18} />
                        </a>
                      </li>

                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Instagram size={18} />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <LucideYoutube size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-center py-7">
                  <h4 className="text-xl md:text-2xl secdory-font">
                    <a href="#" className="no-underline">
                      Valeriia Nadopta
                    </a>
                  </h4>
                  <p className="text-gray-500">Founder, COO</p>
                </div>
              </div>

              {/* Card 4 */}
              <div className="group border-0">
                <div className="relative overflow-hidden">
                  <img
                    src={TeamImg3}
                    alt="John Henry"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex flex-col justify-end items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <ul className="flex gap-6 bg-gray-100 w-full justify-center py-5">
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Twitter size={18} />
                        </a>
                      </li>

                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <Instagram size={18} />
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-md hover:text-primary">
                          <LucideYoutube size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-center py-7">
                  <h4 className="text-xl md:text-2xl secdory-font">
                    <a href="#" className="no-underline">
                      John Henry
                    </a>
                  </h4>
                  <p className="text-gray-500">Founder, Chief Creative</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default AboutUs;
